import React from "react";
import moment from "moment";
import { RouterProvider } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { MusaDesignSystemProvider } from "@musatech/musa-design-system";

import { KeycloakProvider } from "./hooks/useKeycloack";

import "moment/locale/pt-br";

// import router from "./route";
import router from "./route/newRoute";
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import SetAppVersion from "./components/SetAppVersion";

moment.locale("pt-br");

function App() {
  return (
    <MusaDesignSystemProvider>
      <KeycloakProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <SetAppVersion>
              <RouterProvider router={router} />
            </SetAppVersion>
          </PersistGate>
        </Provider>
      </KeycloakProvider>
    </MusaDesignSystemProvider>
  );
}

export default App;
